module.exports = __webpack_public_path__ + "6e78b6e1e437c172ed1f2cb31dd62f55.jpg";